import React from 'react';
import OperationalAlertsArray from '../components/cells/OperationalAlertsArray';
import LazyFolioCell from '../components/cells/lazy-cells/LazyFolioCell';
import LazyFolioInvoiceProfileCell from '../components/cells/lazy-cells/LazyFolioInvoiceProfileCell';
import mergeInvoiceDocumentFinanceState from '../helpers/merge-invoice-document-finance-state';
import { LAZY_QUERIES_NAMES } from './invoice-lazy-columns';

const getDocumentFinanceLazyQueryConfig = ({
  lazyQueryKey = LAZY_QUERIES_NAMES.invoiceDocumentFinanceStateFields.queryKey,
  lazyQueryName = LAZY_QUERIES_NAMES.invoiceDocumentFinanceStateFields.queryName,
} = {}) => ({
  lazyQueryKey,
  lazyQueryName,
});

export const getLazyFolioColumn = ({
  field = 'folio',
  headerName = 'Folio',
  folioCellProps = {},
  lazyQueryKey,
  lazyQueryName,
  orderByField,
  ...columnProps
}) => {
  const { lazyQueryKey: queryKey, lazyQueryName: queryName } = getDocumentFinanceLazyQueryConfig({
    lazyQueryKey,
    lazyQueryName,
  });

  return {
    field,
    headerName,
    disableColumnMenu: true,
    useAdditionalQueries: true,
    queryField: queryKey,
    renderCell: ({ row, additionalQueriesResults }) => (
      <LazyFolioCell
        lazyCellProps={{
          rowId: row.id,
          queryKey,
          queryName,
          additionalQueriesResults,
          showPartialResult: true,
        }}
        folioCellProps={{
          invoice: row,
          ...folioCellProps,
        }}
      />
    ),
    ...columnProps,
    orderByField: orderByField ?? columnProps.orderByField ?? 'folio',
  };
};

export const getLazyFolioInvoiceProfileColumn = ({
  field = 'folio-invoice-profile',
  headerName = 'Folio',
  AlertsArray = OperationalAlertsArray,
  lazyQueryKey,
  lazyQueryName,
  ...columnProps
}) => {
  const { lazyQueryKey: queryKey, lazyQueryName: queryName } = getDocumentFinanceLazyQueryConfig({
    lazyQueryKey,
    lazyQueryName,
  });

  return {
    field,
    headerName,
    type: 'string',
    headerAlign: 'left',
    align: 'left',
    disableColumnMenu: true,
    filterable: false,
    useAdditionalQueries: true,
    queryField: queryKey,
    renderCell: ({ row, additionalQueriesResults }) => (
      <LazyFolioInvoiceProfileCell
        lazyCellProps={{
          rowId: row.id,
          queryKey,
          queryName,
          additionalQueriesResults,
          showPartialResult: true,
        }}
        folioInvoiceProfileCellProps={{
          invoice: row,
          AlertsArray,
        }}
        mergeNode={mergeInvoiceDocumentFinanceState}
      />
    ),
    ...columnProps,
  };
};
